import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
// import './index.css';
import App from './App';
import config from './config/'; 
// import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
// const AppConfig = {
//   locationOrigin: `${window.location.origin}`,
//   baseUrl: `${window.location.protocol}//${window.location.hostname}`,
//   originUrl: (!window.location.origin) ? window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') : `${window.location.origin}`,
//   domain: `${window.location.host}`,
//   protocol: `${window.location.protocol}`,
//   host: `${window.location.host}`,
//   port: `${window.location.port}`,
//   pathname: `${window.location.pathname}`,  // = “/example/index.html”
//   search: `${window.location.search}` 
// }
//   console.log('index.js, locationOrigin',AppConfig.locationOrigin) // it will include :<port-number>
//   console.log(`index.js, baseUrl=${AppConfig.baseUrl}`)
//   console.log('index.js, originUrl',AppConfig.originUrl)
//   console.log('index.js, pathname',AppConfig.pathname)  // / or /index.html  index.js, pathname /build/  index.js, pathname /build/index.html
//   console.log('index.js, search',AppConfig.search)
//   // text.replace("Microsoft", "W3Schools");
//   // text.replace(/blue/g, "red");
//   // string.indexOf(substring) !== -1
//   const SiteContext = React.createContext(AppConfig);
//   let basePath="/";
//   if(AppConfig.pathname.length>0)
//   {
//     if(AppConfig.pathname.toLocaleLowerCase().indexOf('index.html') !== -1){
//       basePath=AppConfig.pathname.toLocaleLowerCase().replace("index.html", "");
//     }
//     else basePath=AppConfig.pathname;
//     //if(basePath=="/") basePath="";
//     //else if(basePath.length>1 && basePath.startsWith("/")) basePath=basePath.substring(1)
//     if(basePath=="") basePath="/";
//   }
//   console.log('index, basePath',basePath,'basename',`${basePath}`)  

// root.render(
//   <BrowserRouter basename={`${process.env.REACT_APP_MAIN_ROOT}${basePath}`}><App /></BrowserRouter>
// );

/*
root.render(
  <BrowserRouter basename={`${basePath}`}><App /></BrowserRouter>
);
*/

/* TypeScript to ignore any type errors on the next line of code */
// @ts-expect-error
const appglobalAppinit = window.myglobalAppinit;

console.log("=JS index=, appglobalAppinit (window.myglobalAppinit)=",appglobalAppinit)
// @ts-expect-error
console.log("=JS index=, myglobalAppinit (from window.myglobalAppinit)=",myglobalAppinit)
// @ts-expect-error
console.log("=JS index=, global js my_public_url=",my_public_url)

console.log("=JS index=, process.env.PUBLIC_URL=",process.env.PUBLIC_URL)

root.render(
  // <BrowserRouter basename={process.env.PUBLIC_URL}><App /></BrowserRouter>
  <BrowserRouter ><App /></BrowserRouter>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
